import React from 'react';
import { CheckCircle2, Download, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function PaymentSuccess({ order, summary }) {
  const downloadUrl = order?.metadata?.download_url;
  return (
    <div className="pg-admin-card rounded-[var(--pg-radius-md)] p-8 text-center" data-testid="payment-success">
      <div className="inline-flex h-14 w-14 rounded-full bg-[rgba(25,194,142,0.14)] border border-[rgba(25,194,142,0.5)] items-center justify-center mb-4">
        <CheckCircle2 size={28} className="text-[var(--pg-emerald-2)]" />
      </div>
      <h2 className="font-serif text-2xl text-[var(--pg-ink)]">Payment received</h2>
      <p className="text-sm text-[var(--pg-ink-muted)] mt-2">
        Thank you for supporting Planet G. A receipt has been sent to your email.
      </p>
      {summary?.title && (
        <p className="text-[11px] font-mono tracking-widest uppercase text-[var(--pg-ink-faint)] mt-3">
          {summary.title}
        </p>
      )}

      {downloadUrl && (
        <a href={downloadUrl} target="_blank" rel="noopener noreferrer" data-testid="payment-success-download"
           className="mt-6 inline-flex items-center gap-2 pg-btn-primary rounded-[var(--pg-radius-sm)] px-4 py-2 text-sm">
          <Download size={14} /> Download your file
        </a>
      )}

      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4">
        <Link to="/vault" className="text-[12px] font-mono tracking-widest text-[var(--pg-ink-muted)] hover:text-[var(--pg-ink)] inline-flex items-center gap-1">
          Continue exploring the Vault <ArrowRight size={12} />
        </Link>
        <Link to="/" className="text-[12px] font-mono tracking-widest text-[var(--pg-ink-faint)] hover:text-[var(--pg-ink)]">
          Back to Home
        </Link>
      </div>
    </div>
  );
}
